// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
export { default } from '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/node_modules/dumi/theme-default/slots/PreviewerActions/index.js';
